import router from "@/router";

const state = {
  token: JSON.parse(window.localStorage.getItem("cassems_token")),
  user: window.localStorage.getItem("cassems_user"),
  roles: JSON.parse(window.localStorage.getItem("cassems_roles")) || [],
};

const mutations = {
  login(state, payload) {
    window.localStorage.setItem("cassems_token", JSON.stringify(payload.token));
    window.localStorage.setItem("cassems_user", payload.name);
    window.localStorage.setItem("cassems_roles", JSON.stringify(payload.roles));
    state.token = payload.token;
    state.user = payload.name;
    state.roles = payload.roles;
  },
  logout(state) {
    window.localStorage.removeItem("cassems_token");
    window.localStorage.removeItem("cassems_user");
    window.localStorage.removeItem("cassems_roles");
    state.token = undefined;
    state.user = undefined;
    state.roles = undefined;
  },
};

const actions = {
  async login({ commit }, payload) {
    commit("login", payload);
  },
  async logout({ commit }) {
    commit("logout");
    router.push({ name: "auth.login" });
  },
};

const getters = {
  isLogged(state) {
    return !!state.token;
  },
  token(state) {
    return state?.token;
  },
  userName(state) {
    return state?.user;
  },
  roles(state) {
    return state?.roles;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
